import React from 'react';
import { Link } from "gatsby";
import headerStyles from '../styles/header.module.scss'
import burgerStyles from '../styles/burger.module.scss'
import { css } from "@emotion/core"

 
const Menu = () => (
    
        <nav className={headerStyles.navMenu}>
            <Link className={headerStyles.menu} activeClassName={burgerStyles.nav_item_active} to="/">Inicio</Link>
            <Link className={headerStyles.menu} activeClassName={burgerStyles.nav_item_active} to="/sobre-mi">¿Quién soy?</Link>
            <Link className={headerStyles.menu} activeClassName={burgerStyles.nav_item_active} to="/diseno-web-sevilla">Diseño web</Link>
            <Link className={headerStyles.menu} activeClassName={burgerStyles.nav_item_active} to="/diseno-tienda-online-sevilla">Tiendas online</Link>
            <Link className={headerStyles.menu} activeClassName={burgerStyles.nav_item_active} to="/portfolio">Portfolio</Link>
            <Link className={headerStyles.menu} activeClassName={burgerStyles.nav_item_active} to="/blog">Blog</Link>
            <Link className={headerStyles.menu} activeClassName={burgerStyles.nav_item_active} to="/contacto"><span css={css`text-transform: uppercase; font-weight:600;`}>Solicita presupuesto gratis</span></Link>
        </nav>
  
);


export default Menu